import { useSyncExternalStore } from "react";

type Listener = () => void;

const listeners = new Set<Listener>();
let listening = false;

function getSnapshot(): boolean {
  return document.visibilityState !== "hidden";
}

function notifyListeners(): void {
  listeners.forEach((listener) => listener());
}

function startListening(): void {
  if (listening) return;
  document.addEventListener("visibilitychange", notifyListeners);
  listening = true;
}

function stopListening(): void {
  if (!listening || listeners.size > 0) return;
  document.removeEventListener("visibilitychange", notifyListeners);
  listening = false;
}

function subscribe(listener: Listener): () => void {
  listeners.add(listener);
  startListening();
  return () => {
    listeners.delete(listener);
    stopListening();
  };
}

export function useDocumentVisible(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, () => true);
}
